import React, { Component } from 'react';
import Framework from "@beardeddevops/react.framework";
import {Objects, Types} from "components";

import API from "@beardeddevops/react.api";

import SendToKioskObject from "./SendToKiosk";
import {Button, ButtonGroup} from "reactstrap";
import TransactionObject from "components/TransactionObject";
import ObjectOverride from "components/ObjectOverride";


class AmmoReadyConfig extends ObjectOverride {
	constructor(props) {
		super(props, Types.Products._name);
		// this.loadBrands().then();
		this.loadCategories().then();
		this.loadCalibers().then();
	}


	componentDidMount() {
		super.componentDidMount();
		if(this.props.productInfo) {
			this.setState({
				'ammoready_name': this.props.productInfo.serial_number,
				'ammoready_price': this.props.productInfo.price_list,
				'ammoready_cost': this.props.productInfo.cost,
				'ammoready_brand': this.props.productInfo.manufacturers ? this.props.productInfo.manufacturers.name : this.props.productInfo.manufacturer_other,
				'ammoready_length': this.props.productInfo.overall_length,
				'sku': this.props.productInfo.sku,
				'upc': this.props.productInfo.upc,
				'tag_note': this.props.productInfo.tag_note,
				'p_id': this.props.productInfo._id
			})
		}


	}

	async loadCategories() {
		let spModel = new API.BuildClass(Types.Products._name, 'GET_AMMOREADY_CATEGORIES');
		let categories = await spModel.submit(null, 'GET_AMMOREADY_CATEGORIES');
		this.setState({categories: categories['categories']});
	}

	async loadBrands() {
		let spModel = new API.BuildClass(Types.Products._name, 'GET_AMMOREADY_BRANDS');
		let brands = await spModel.submit(null, 'GET_AMMOREADY_BRANDS');
		this.setState({brands});
	}

	async loadCalibers() {
		let spModel = new API.BuildClass(Types.Products._name, 'GET_AMMOREADY_CALIBERS');
		let calibers = await spModel.submit(null, 'GET_AMMOREADY_CALIBERS');
		this.setState({calibers: calibers['calibers']});
	}


	async handleSubmit() {
		this.setState({loading: true})
		let aModel = new API.BuildClass(Types.Products._name, 'PUT_AMMOREADY_PRODUCT');
		try {
			let result = await aModel.submit(this, 'PUT_AMMOREADY_PRODUCT');
			this.setState({loading: false});
			window.open(`https://app.ammoreadycloud.com/manage/products/${result['response'].id}`, "_blank");
			this.props.history.push('/');
			this.props.history.push('products#ammoready_products');
		}
		catch(err) {
			this.setState({loading: false})
		}


	}

	render() {
		const object = this.state;
		/** @type {Product_Properties} properties */
		let properties = this.model.properties;

		return (

			<div>
				<fieldset>
					<div>

						<h4 className="section-title">Firearm Required Information</h4>
						<div className={"row"}>
							<div className={"col-6"}>
								<Framework.Elements.TextField
									label={"Name"}
									property={this.model.properties.ammoready_name}
									value={object.ammoready_name}
									error={object.ammoready_name_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={"col-6"}>
								<Framework.Elements.TextField
									label={"Manufacturer"}
									property={this.model.properties.ammoready_brand}
									value={object.ammoready_brand}
									error={object.ammoready_brand_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>

						<div className={"row"} style={{marginTop: "20px"}}>
							<div className={"col-6"}>
								<Framework.Elements.TextField
									label={"$ Price"}
									property={this.model.properties.ammoready_price}
									value={object.ammoready_price}
									error={object.ammoready_price_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={"col-6"}>
								<Framework.Elements.Select
									// style={{paddingTop: "20px"}}
									label={"Categories"}
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									objects={this.state.categories}
									property={this.model.properties.ammoready_category}
									value={object.ammoready_category}
									error={object.ammoready_category_error}
									text={'name&parent_category'}
									nullable={true}
									limit={null}
								/>
							</div>

						</div>
						<h4 className="section-title" style={{marginTop: "40px"}}>Firearm Optional Information</h4>
						<div className={"row"} style={{marginTop: "20px"}}>
							<div className={"col-6"}>
								<Framework.Elements.Select
									// style={{paddingTop: "20px"}}
									label={"Condition"}
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									objects={[
										{pkey: '1', name: 'Stock'},
										{pkey: '2', name: 'Used'},
										{pkey: '3', name: 'Remanufactured'},
									]}
									property={this.model.properties.ammoready_condition}
									value={object.ammoready_condition}
									error={object.ammoready_condition_error}
									text={'name'}
									nullable={true}
									limit={null}
								/>
							</div>
							<div className={"col-6"}>
								<Framework.Elements.Select
									// style={{paddingTop: "20px"}}
									label={"Shipping Restriction"}
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									objects={[
										{pkey: '1', name: 'None'},
										{pkey: '2', name: 'Hazmat Ground'},
										{pkey: '3', name: 'Hazmat Air'},
									]}
									property={this.model.properties.ammoready_shipping_restriction}
									value={object.ammoready_shipping_restriction}
									error={object.ammoready_shipping_restriction_error}
									text={'name'}
									nullable={true}
									limit={null}
								/>
							</div>
						</div>

						<div className={"row"} style={{marginTop: "20px"}}>
							<div className={"col-6"}>
								<Framework.Elements.TextField
									label={"$ Cost"}
									property={this.model.properties.ammoready_cost}
									value={object.ammoready_cost}
									error={object.ammoready_cost_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={"col-6"}>
								<Framework.Elements.Select
									// style={{paddingTop: "20px"}}
									label={"Firearm Type"}
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									objects={[
										{pkey: '1', name: 'Handgun'},
										{pkey: '3', name: 'Long Gun'},
										{pkey: '4', name: 'Ammunition'},
										{pkey: '5', name: 'Suppressor'},
									]}
									property={this.model.properties.ammoready_type}
									value={object.ammoready_type}
									error={object.ammoready_type_error}
									text={'name'}
									nullable={true}
									limit={null}
								/>
							</div>
						</div>

						<div className={"row"} style={{marginTop: "20px"}}>
							<div className={"col-6"}>
								<Framework.Elements.TextField
									label={"SKU"}
									property={this.model.properties.sku}
									value={object.sku}
									error={object.sku_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={"col-6"}>
								<Framework.Elements.TextField
									label={"UPC"}
									property={this.model.properties.upc}
									value={object.upc}
									error={object.upc_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={"row"} style={{marginTop: "20px"}}>
							<div className={"col-6"}>
								<Framework.Elements.TextField
									label={"MFG Part Number"}
									property={this.model.properties.mfg_part_number}
									value={object.mfg_part_number}
									error={object.mfg_part_number_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={"col-6"}>
								<Framework.Elements.Select
									// style={{paddingTop: "20px"}}
									label={"Caliber"}
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									objects={this.state.calibers}
									property={this.model.properties.ammoready_caliber}
									value={object.ammoready_caliber}
									error={object.ammoready_caliber_error}
									text={'name'}
									nullable={true}
									limit={null}
								/>
							</div>
						</div>
						<div className={"row"} style={{marginTop: "20px"}}>
							<div className={"col-6"}>
								<Framework.Elements.Select
									// style={{paddingTop: "20px"}}
									label={"ATF Type"}
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									objects={[
										{pkey: '1', name: 'combination'},
										{pkey: '2', name: 'frame'},
										{pkey: '3', name: 'other'},
										{pkey: '4', name: 'pistol'},
										{pkey: '5', name: 'pistol_grip_firearm'},
										{pkey: '6', name: 'receiver'},
										{pkey: '7', name: 'revolver'},
										{pkey: '8', name: 'rifle'},
										{pkey: '9', name: 'shotgun'},
										{pkey: '10', name: 'Nfa Any Other Weapon'},
										{pkey: '11', name: 'Nfa Destructive Device'},
										{pkey: '12', name: 'Nfa Machine Gun'},
										{pkey: '13', name: 'Nfa Short barrel Rifle'},
										{pkey: '14', name: 'Nfa Short Barrel Shotgun'},
										{pkey: '15', name: 'Nfa Silencer'},
									]}
									property={this.model.properties.atf_type}
									value={object.atf_type}
									error={object.atf_type_error}
									text={'name'}
									nullable={true}
									limit={null}
								/>
							</div>
							<div className={"col-6"}>
								<Framework.Elements.TextField
									label={"MAP Price"}
									property={this.model.properties.map_price}
									value={object.map_price}
									error={object.map_price_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={"row"} style={{marginTop: "20px"}}>
							<div className={"col-6"}>
								<Framework.Elements.TextField
									label={"Length (in IN)"}
									property={this.model.properties.ammoready_length}
									value={object.ammoready_length}
									error={object.ammoready_length_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={"col-6"}>
								<Framework.Elements.TextField
									label={"Width (in IN)"}
									property={this.model.properties.ammoready_width}
									value={object.ammoready_width}
									error={object.ammoready_width_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>

						<div className={"row"} style={{marginTop: "20px"}}>
							<div className={"col-6"}>
								<Framework.Elements.TextField
									label={"Height (in IN)"}
									property={this.model.properties.ammoready_height}
									value={object.ammoready_height}
									error={object.ammoready_height_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={"col-6"}>
								<Framework.Elements.TextField
									label={"Weight (in LBS)"}
									property={this.model.properties.ammoready_weight}
									value={object.ammoready_weight}
									error={object.ammoready_weight_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={"row"} style={{marginTop: "20px"}}>
							<div className={"col-12"}>
								<Framework.Elements.TextField
									label={"Description"}
									property={this.model.properties.tag_note}
									value={object.tag_note}
									error={object.tag_note_error}
									multiline={4}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
				</fieldset>
				<Framework.Elements.LoadingSpinner isLoading={this.state.loading}/>

			</div>
		);
	}
}

export default Framework.Components.withRootState(AmmoReadyConfig);
